import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-college-capacity-diallog-box',
  templateUrl: './college-capacity-diallog-box.component.html',
  styleUrls: ['./college-capacity-diallog-box.component.scss']
})
export class CollegeCapacityDiallogBoxComponent implements OnInit {
  selectedValue: string;
  codeForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showTable = false;
  showSubmitButton = true;
  codeList: any;
  list;
  CodeSearchForm;
  APIService: any;
  isReadonly = false;
  isReadonlyDelete = false;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  codeTypeList: any;
  filteredCodeType: any;
  desLabel: any;
  x = sessionStorage.getItem('CdType');
  y = sessionStorage.getItem('CdDesc');
  CdCode;
  CdType;
  CodeType: string;
  @Output() prev = new EventEmitter<void>();
  userPermission: any;
  utp: string;
  CodeCreate = true;
  CodeUpdate = true;
  CodeDelete = true;
  blockCheck: any;
  key: any;
  arr: any[] = [];
  currentEditingId: any;
  blockData: any;
  uploadArray: any[]=[]

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.key = this.data.key
    this.fetchSecretData()
    if (this.key == 'blk') {
      this.fetchBlockData()
    }


    this.CdCode = sessionStorage.getItem('CdCode');
    this.CdType = sessionStorage.getItem('CdType');
    this.x = sessionStorage.getItem('CdType');
    this.y = sessionStorage.getItem('CdDesc');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach((element) => {
        if (element.PageName == 'Code' && element.PCreate == false) {
          this.CodeCreate = false;
        }
        if (element.PageName == 'Code' && element.PUpdate == false) {
          this.CodeUpdate = false;
        }
        if (element.PageName == 'Code' && element.PDelete == false) {
          this.CodeDelete = false;
        }
      });
    }
    let k = this.CdType;
    this.list = true;
    this.showTable = false;
    this.submitButton = true;
    this.editButton = false;
    this.isReadonly = false;
    this.isReadonlyDelete = false;
    this.deleteButton = false;
    this.codeForm = this.fb.group({
      BlockId: new FormControl(''),
      CgCode: new FormControl(this.data.selected.CgCode),
      CgName: new FormControl(this.data.selected.CgName),
      BlockName: new FormControl('', [Validators.required]),
      BlockCapacity: new FormControl('', [Validators.required]),
      Capacity: new FormControl(this.data.selected.Capacity)
    });
    this.CodeSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
  }

  prepopulation(id) {
    this.isReadonlyDelete = false;
    this.isReadonly = true;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.codeForm = this.fb.group({
      CdType: new FormControl(id.CdType, [Validators.required]),
      CdCode: new FormControl(id.CdCode, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
        Validators.maxLength(6),
      ]),
      CdDesc: new FormControl(id.CdDesc, [Validators.required]),
      CdSeq: new FormControl(id.CdSeq, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(4),
      ]),
      CdActive: new FormControl(id.CdActive, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]*$'),
      ]),
      CdProc: new FormControl(id.CdProc, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),
      ]),
      desLabel: new FormControl(this.y),
    });
    this.redirect('code');
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      const result = res.projectPharam['ActiveFlow']
      let data = []
      data = JSON.parse(result)

      this.blockCheck = data[0].CollegeBlockCapacity;
    }
    );
  }


  fetchBlockData() {
    const payload = {};
    payload['CgCode'] = this.data.selected.CgCode ? this.data.selected.CgCode : 0;
    this.umsService.getBlock(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status == true) {
          this.showTable = true;
          this.blockData = res.data

        } 
        else{
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information'; 
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
        
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  update() {

    if (this.codeForm.invalid) {
      this.codeForm.get('BlockName').markAsTouched();
      this.codeForm.get('BlockCapacity').markAsTouched();
      return;
    } else {
      this.updateCode();
    }
  }

  updateCode() {
    this.spinner.show();
    const submitpayload = this.codeForm.value
    const payload = {};
    payload['BlockId'] = this.currentEditingId;
    payload['BlockName'] = submitpayload.BlockName;
    payload['CgCode'] = submitpayload.CgCode;
    //payload['CgName'] = submitpayload.CgName;
    payload['BlockCapacity'] = submitpayload.BlockCapacity;
    this.uploadArray.push(payload)
    this.umsService.updateBlock(this.uploadArray).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.fetchBlockData();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }


  redirect(to): void {
    this.router.navigate([to]);
  }

  // deletee(e, k) {
  //   if (e === 'true') {
  //     this.list = false;
  //     // this.getCodeData();
  //     this.prepopulationForDelete(k);
  //   } else {
  //     this.list = true;
  //   }
  // }

  // prepopulationForDelete(id) {
  //   this.editButton = false;
  //   this.submitButton = false;
  //   this.deleteButton = true;
  //   this.isReadonlyDelete = true;
  //   this.isReadonly = true;
  //   this.codeForm = this.fb.group({
  //     CdType: new FormControl(id.CdType, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$'),]),
  //     CdCode: new FormControl(id.CdCode, [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$'), Validators.maxLength(6),]),
  //     CdDesc: new FormControl(id.CdDesc, [Validators.required]),
  //     CdSeq: new FormControl(id.CdSeq, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(4),]),
  //     CdActive: new FormControl(id.CdActive, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$'),]),
  //     CdProc: new FormControl(id.CdProc, [Validators.required, Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),]),
  //   });
  // }

  openConformationModalBox() {
    let data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deletedata(this.codeForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }

  deletedata(item) {

    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        BlockId: item.BlockId,
        BlockName: item.BlockName,
        CgCode: item.CgCode,
       // CgName: item.CgName,
        BlockCapacity: item.BlockCapacity
      },
    };
    this.httpClient
      .delete(this.APIService + '/masters/DeleteCollegeBlock', options)
      .subscribe(
        (s) => {
          this.spinner.hide();
          let cc = [];
          cc.push(s);
          let data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.fetchBlockData();
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.fetchBlockData();
        }
      );
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      // this.getCodeData(i);
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.isReadonly = false;
      this.isReadonlyDelete = false;
      this.codeForm.reset();
    } else {
      this.list = true;
      this.ngOnInit();
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
      this.isReadonly = false;
      this.isReadonlyDelete = false;
    }
  }

  submit() {
    if (this.codeForm.invalid) {
      this.codeForm.get('CdType').markAsTouched();
      this.codeForm.get('CdCode').markAsTouched();
      this.codeForm.get('CdDesc').markAsTouched();
      this.codeForm.get('CdSeq').markAsTouched();
      this.codeForm.get('CdActive').markAsTouched();
      this.codeForm.get('CdProc').markAsTouched();
      return;
    } else {
      this.createCode();
    }
  }

  createCode() {
    this.spinner.show();
    const payload = this.codeForm.value;
    this.umsService.addCode(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchCodeType(id) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = '99999';
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.codeList = res.data;
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }



  back() {
    this.prev.emit();
  }

  // add() {
  //   const payload = this.codeForm.value;

  //   // Check for duplicate BlockName
  //   const isDuplicate = this.arr.some(item => item.BlockName === payload.BlockName);

  //   if (isDuplicate) {
  //     // alert('Block Name already exists. Please enter a unique name.'); // You can replace this with a toast or snackbar
  //     let data = {};
  //     data['message'] = 'Block Name already exists. Please enter a unique name.';
  //     data['title'] = 'Information';
  //     data['icon'] = 'fas fa-close';
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //       AlertBoxComponent,
  //       data
  //     );
  //     return; // Stop the function from proceeding
  //   }

  //   this.arr.push(payload);  // Add only if not duplicate

  //   console.log(this.arr);   // Optional: for debugging
  // }

  edit(item: any) {
    this.codeForm.patchValue({
      BlockName: item.BlockName,
      CgCode: item.CgCode,
      CgName: item.CgName,
      BlockCapacity: item.BlockCapacity
    });
    this.currentEditingId = item.BlockId; // Store current editing block ID
    this.editButton = true; // Enable Update button
    this.submitButton = false; // Optional: Used for *ngIf condition
    this.deleteButton = false; // Optional: Used for *ngIf condition


  }

  saveBlock() {
    const payload = this.codeForm.value;

    // Check for duplicate BlockName
    const isDuplicate = this.arr.some(item => item.BlockName === payload.BlockName);

    if (isDuplicate) {
      // alert('Block Name already exists. Please enter a unique name.'); // You can replace this with a toast or snackbar
      let data = {};
      data['message'] = 'Block Name already exists. Please enter a unique name.';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      return; // Stop the function from proceeding
    }
    this.umsService.saveBlock(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.fetchBlockData();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  saveCapacity() {
    const data = this.codeForm.value
    const payload = {};
    payload['CgCode'] = data.CgCode;
    payload['Capacity'] = parseInt(data.Capacity);
    this.umsService.saveCapacity(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }


  remove(item: any) {
    // const index = this.arr.indexOf(item);
    // if (index > -1) {
    //   this.arr.splice(index, 1); // remove the item from the array
    // }
    this.codeForm.patchValue({
      BlockId: item.BlockId,
      BlockName: item.BlockName,
      CgCode: item.CgCode,
      CgName: item.CgName,
      BlockCapacity: item.BlockCapacity
    });
    this.deleteButton = true;
    this.submitButton = false;
    this.editButton = false;

    // this.openConformationModalBox()
  }
}